import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.company.list');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-company-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.lpsysadmin.company.list/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCompanyListComponent implements OnInit {
    @Input() view: any;
    @Input() category: any = 'investment';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.view == "admin") await this.service.auth.allow.membership(['admin', 'super_admin'], "/landing");
        else await this.service.auth.allow(true, "/landing");
        await this.load();
    }

    public loading: boolean = false;
    public list: any = [];
    public search: any = {
        text: "",
        page: 1,
        dump: 200
    }

    public pagination: any = {
        end: -1,
        start: -1,
        current: 0
    }

    public sortField: string = '';
    public sortOrder: string = 'ASC';

    public gradeOrder: any = { 'S': 1, 'A': 2, 'B': 3, 'C': 4, 'D': 5, '': 6 };
    public gradeStyle: any = {
        'S': 'bg-blue-100 text-blue-700 border border-blue-300',
        'A': 'bg-emerald-100 text-emerald-700 border border-emerald-300',
        'B': 'bg-yellow-100 text-yellow-700 border border-yellow-300',
        'C': 'bg-orange-100 text-orange-700 border border-orange-300',
        'D': 'bg-red-100 text-red-700 border border-red-300',
    };

    public async toggleSort(field: string) {
        if (this.sortField === field) {
            this.sortOrder = this.sortOrder === 'ASC' ? 'DESC' : 'ASC';
        } else {
            this.sortField = field;
            const numericFields = ['investment_amount'];
            this.sortOrder = numericFields.includes(field) ? 'DESC' : 'ASC';
        }
        const dir = this.sortOrder === 'ASC' ? 1 : -1;
        this.list.sort((a, b) => {
            let va: any, vb: any;
            if (field === 'company_name') {
                va = a.company_name || ''; vb = b.company_name || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'description') {
                va = a.description || ''; vb = b.description || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'location') {
                va = a.extra?.location_short || ''; vb = b.extra?.location_short || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'fund_name') {
                va = (a.investment && a.investment[0]?.fund_name) || '';
                vb = (b.investment && b.investment[0]?.fund_name) || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'ceo') {
                va = a.ceo || ''; vb = b.ceo || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'ceo_phone') {
                va = a.ceo_phone || ''; vb = b.ceo_phone || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'manager') {
                va = a.manager || ''; vb = b.manager || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'manager_phone') {
                va = a.manager_phone || ''; vb = b.manager_phone || '';
                return va.localeCompare(vb, 'ko') * dir;
            } else if (field === 'latest_grade') {
                va = this.gradeOrder[a.latest_grade] || 6;
                vb = this.gradeOrder[b.latest_grade] || 6;
                return (va - vb) * dir;
            }
            return 0;
        });
        await this.service.render();
    }

    public sortIcon(field: string): string {
        if (this.sortField !== field) return ' ↕';
        return this.sortOrder === 'ASC' ? ' ▲' : ' ▼';
    }

    public async load(page: number = 1) {
        if (this.loading) return;
        this.loading = true;
        this.pagination.current = page;
        this.search.page = page;
        this.search.status = this.category;
        this.list = [];
        await this.service.render();

        const { code, data } = await wiz.call("search", this.search);
        console.log(data)

        if (code == 200) {
            let { rows, lastpage } = data;
            const startpage = Math.floor((page - 1) / 10) * 10 + 1;
            this.list = rows;
            this.pagination.start = startpage;
            this.pagination.end = lastpage;
        }

        this.loading = false;
        await this.service.render();
    }

    public iterItems(item: any) {
        if (item.investment.length == 0) {
            let row: any = JSON.parse(JSON.stringify(item));
            row.investment = {};
            row._rowspan = 1;
            return [row];
        }

        let rows: any = [];
        for (let i = 0; i < item.investment.length; i++) {
            let row: any = JSON.parse(JSON.stringify(item));
            if (i == 0) row._rowspan = item.investment.length;
            row.investment = item.investment[i];
            rows.push(row);
        }

        return rows;
    }

    public async removeItem(item) {
        let res = await this.service.alert.error("기업 정보를 삭제하시겠습니까?", "취소", "삭제");
        if (!res) return;
        const { code } = await wiz.call("remove", item);
        if (code !== 200) return alert("조합 삭제 실패!");
        await this.load(this.pagination.current);
    }

    public crawling: boolean = false;

    public async crawl() {
        let res = await this.service.alert.show({
            title: "뉴스 크롤링",
            message: "모든 투자기업의 최신 뉴스를 크롤링하시겠습니까?",
            cancel: "취소",
            actionBtn: "info",
            action: "크롤링",
            status: "info"
        });
        if (!res) return;
        this.crawling = true;
        await this.service.render();
        const { code, data } = await wiz.call("crawl");
        this.crawling = false;
        await this.service.render();
        if (code == 200) {
            let msg = `총 ${data.total_companies}개 기업 검색, ${data.company_count}개 기업에서 ${data.inserted}건의 새로운 뉴스가 등록되었습니다.`;
            if (data.errors && data.errors.length > 0) {
                msg += ` (${data.errors.length}건 오류)`;
            }
            await this.service.alert.show({
                title: "크롤링 완료",
                message: msg,
                actionBtn: "success",
                action: "확인",
                status: "success"
            });
        } else {
            await this.service.alert.show({
                title: "오류",
                message: data?.message || "크롤링에 실패했습니다.",
                actionBtn: "error",
                action: "확인",
                status: "error"
            });
        }
    }

    public statusMap(item) {
        if (item.investment_status == '운영') return 'operation';
        if (item.investment_status == '해산') return 'exit';
        return 'formed';
    }

    public baseLink(uri: string) {
        if (this.category == 'meeting') {
            return '/admin/invest/meeting_company' + uri;
        }
        if (this.category == 'review') {
            return '/admin/invest/review_company' + uri;
        }
        return '/admin/invest/company' + uri;
    }
}

export default PortalLpsysadminCompanyListComponent;